/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  PsCheck,
  ErrorInfo,
  GetPsCheckParams,
  PsCheckUpdate,
  BinaryFile,
  GetPsCheckDownloadParams,
  PsCheckChecks,
  GetPsCheckCheckListParams,
  PsCheckApproves,
  GetPsCheckApproveListParams
} from '.././model'


/**
 * PS改廃案承認情報を取得する。

 * @summary PS改廃案承認情報取得
 */
export const getPsCheck = (
    psVersionId: number,
    params?: GetPsCheckParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsCheck>> => {
    return axios.get(
      `/pschecks/${psVersionId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetPsCheckQueryKey = (psVersionId: number,
    params?: GetPsCheckParams,) => [`/pschecks/${psVersionId}`, ...(params ? [params]: [])];

    
export type GetPsCheckQueryResult = NonNullable<Awaited<ReturnType<typeof getPsCheck>>>
export type GetPsCheckQueryError = AxiosError<ErrorInfo>

export const useGetPsCheck = <TData = Awaited<ReturnType<typeof getPsCheck>>, TError = AxiosError<ErrorInfo>>(
 psVersionId: number,
    params?: GetPsCheckParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsCheck>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsCheckQueryKey(psVersionId,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsCheck>>> = ({ signal }) => getPsCheck(psVersionId,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsCheck>>, TError, TData>(queryKey, queryFn, {enabled: !!(psVersionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PS改廃案承認情報を更新する。

 * @summary PS改廃案承認情報更新
 */
export const postPsCheck = (
    psVersionId: number,
    psCheckUpdate: PsCheckUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsCheck>> => {const formData = new FormData();
if(psCheckUpdate.change_request_section !== undefined) {
 formData.append('change_request_section', psCheckUpdate.change_request_section)
 }
if(psCheckUpdate.release_note !== undefined) {
 formData.append('release_note', psCheckUpdate.release_note)
 }
if(psCheckUpdate.message !== undefined) {
 formData.append('message', psCheckUpdate.message)
 }
if(psCheckUpdate.comment !== undefined) {
 formData.append('comment', psCheckUpdate.comment)
 }
if(psCheckUpdate['files[]'] !== undefined) {
 psCheckUpdate['files[]'].forEach(value => formData.append('files[]', value));
 }

    return axios.post(
      `/pschecks/${psVersionId}`,
      formData,options
    );
  }



    export type PostPsCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postPsCheck>>>
    export type PostPsCheckMutationBody = PsCheckUpdate
    export type PostPsCheckMutationError = AxiosError<ErrorInfo>

    export const usePostPsCheck = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsCheck>>, TError,{psVersionId: number;data: PsCheckUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsCheck>>, {psVersionId: number;data: PsCheckUpdate}> = (props) => {
          const {psVersionId,data} = props ?? {};

          return  postPsCheck(psVersionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsCheck>>, TError, {psVersionId: number;data: PsCheckUpdate}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS改廃案承認情報を一件削除する。

 * @summary PS改廃案承認情報削除
 */
export const postPsCheckDelete = (
    psVersionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/pschecks/${psVersionId}/delete`,undefined,options
    );
  }



    export type PostPsCheckDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postPsCheckDelete>>>
    
    export type PostPsCheckDeleteMutationError = AxiosError<ErrorInfo>

    export const usePostPsCheckDelete = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsCheckDelete>>, TError,{psVersionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsCheckDelete>>, {psVersionId: number}> = (props) => {
          const {psVersionId} = props ?? {};

          return  postPsCheckDelete(psVersionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsCheckDelete>>, TError, {psVersionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS改廃案を確認申請する。

 * @summary PS改廃案確認申請
 */
export const postPsCheckApplication = (
    psVersionId: number,
    psCheckUpdate: PsCheckUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsCheck>> => {
    return axios.post(
      `/pschecks/${psVersionId}/application`,
      psCheckUpdate,options
    );
  }



    export type PostPsCheckApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof postPsCheckApplication>>>
    export type PostPsCheckApplicationMutationBody = PsCheckUpdate
    export type PostPsCheckApplicationMutationError = AxiosError<ErrorInfo>

    export const usePostPsCheckApplication = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsCheckApplication>>, TError,{psVersionId: number;data: PsCheckUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsCheckApplication>>, {psVersionId: number;data: PsCheckUpdate}> = (props) => {
          const {psVersionId,data} = props ?? {};

          return  postPsCheckApplication(psVersionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsCheckApplication>>, TError, {psVersionId: number;data: PsCheckUpdate}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS改廃案申請を確認する。

 * @summary PS改廃案申請確認
 */
export const postPsCheckCheck = (
    psVersionId: number,
    psCheckUpdate: PsCheckUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsCheck>> => {
    return axios.post(
      `/pschecks/${psVersionId}/check`,
      psCheckUpdate,options
    );
  }



    export type PostPsCheckCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postPsCheckCheck>>>
    export type PostPsCheckCheckMutationBody = PsCheckUpdate
    export type PostPsCheckCheckMutationError = AxiosError<ErrorInfo>

    export const usePostPsCheckCheck = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsCheckCheck>>, TError,{psVersionId: number;data: PsCheckUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsCheckCheck>>, {psVersionId: number;data: PsCheckUpdate}> = (props) => {
          const {psVersionId,data} = props ?? {};

          return  postPsCheckCheck(psVersionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsCheckCheck>>, TError, {psVersionId: number;data: PsCheckUpdate}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS改廃案申請を承認する。

 * @summary PS改廃案申請承認
 */
export const postPsCheckApprove = (
    psVersionId: number,
    psCheckUpdate: PsCheckUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsCheck>> => {
    return axios.post(
      `/pschecks/${psVersionId}/approve`,
      psCheckUpdate,options
    );
  }



    export type PostPsCheckApproveMutationResult = NonNullable<Awaited<ReturnType<typeof postPsCheckApprove>>>
    export type PostPsCheckApproveMutationBody = PsCheckUpdate
    export type PostPsCheckApproveMutationError = AxiosError<ErrorInfo>

    export const usePostPsCheckApprove = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsCheckApprove>>, TError,{psVersionId: number;data: PsCheckUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsCheckApprove>>, {psVersionId: number;data: PsCheckUpdate}> = (props) => {
          const {psVersionId,data} = props ?? {};

          return  postPsCheckApprove(psVersionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsCheckApprove>>, TError, {psVersionId: number;data: PsCheckUpdate}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS改廃案申請を差し戻しする。

 * @summary PS改廃案申請差し戻し
 */
export const postPsCheckRemand = (
    psVersionId: number,
    psCheckUpdate: PsCheckUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsCheck>> => {
    return axios.post(
      `/pschecks/${psVersionId}/remand`,
      psCheckUpdate,options
    );
  }



    export type PostPsCheckRemandMutationResult = NonNullable<Awaited<ReturnType<typeof postPsCheckRemand>>>
    export type PostPsCheckRemandMutationBody = PsCheckUpdate
    export type PostPsCheckRemandMutationError = AxiosError<ErrorInfo>

    export const usePostPsCheckRemand = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsCheckRemand>>, TError,{psVersionId: number;data: PsCheckUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsCheckRemand>>, {psVersionId: number;data: PsCheckUpdate}> = (props) => {
          const {psVersionId,data} = props ?? {};

          return  postPsCheckRemand(psVersionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsCheckRemand>>, TError, {psVersionId: number;data: PsCheckUpdate}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS改廃案の添付ファイルを一括ダウンロードする。

 * @summary PS改廃案添付ファイルダウンロード
 */
export const getPsCheckDownload = (
    psVersionId: number,
    params?: GetPsCheckDownloadParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/pschecks/${psVersionId}/download`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetPsCheckDownloadQueryKey = (psVersionId: number,
    params?: GetPsCheckDownloadParams,) => [`/pschecks/${psVersionId}/download`, ...(params ? [params]: [])];

    
export type GetPsCheckDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getPsCheckDownload>>>
export type GetPsCheckDownloadQueryError = AxiosError<ErrorInfo>

export const useGetPsCheckDownload = <TData = Awaited<ReturnType<typeof getPsCheckDownload>>, TError = AxiosError<ErrorInfo>>(
 psVersionId: number,
    params?: GetPsCheckDownloadParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsCheckDownload>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsCheckDownloadQueryKey(psVersionId,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsCheckDownload>>> = ({ signal }) => getPsCheckDownload(psVersionId,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsCheckDownload>>, TError, TData>(queryKey, queryFn, {enabled: !!(psVersionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PS改廃案の確認申請件数を取得する。

 * @summary PS改廃案確認申請件数取得
 */
export const getPsCheckCheckCount = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    return axios.get(
      `/pschecks/checkcount`,options
    );
  }


export const getGetPsCheckCheckCountQueryKey = () => [`/pschecks/checkcount`];

    
export type GetPsCheckCheckCountQueryResult = NonNullable<Awaited<ReturnType<typeof getPsCheckCheckCount>>>
export type GetPsCheckCheckCountQueryError = AxiosError<ErrorInfo>

export const useGetPsCheckCheckCount = <TData = Awaited<ReturnType<typeof getPsCheckCheckCount>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsCheckCheckCount>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsCheckCheckCountQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsCheckCheckCount>>> = ({ signal }) => getPsCheckCheckCount({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsCheckCheckCount>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PS改廃案の確認申請一覧を取得する。

 * @summary PS改廃案確認申請一覧取得
 */
export const getPsCheckCheckList = (
    params?: GetPsCheckCheckListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsCheckChecks>> => {
    return axios.get(
      `/pschecks/checklist`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetPsCheckCheckListQueryKey = (params?: GetPsCheckCheckListParams,) => [`/pschecks/checklist`, ...(params ? [params]: [])];

    
export type GetPsCheckCheckListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsCheckCheckList>>>
export type GetPsCheckCheckListQueryError = AxiosError<ErrorInfo>

export const useGetPsCheckCheckList = <TData = Awaited<ReturnType<typeof getPsCheckCheckList>>, TError = AxiosError<ErrorInfo>>(
 params?: GetPsCheckCheckListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsCheckCheckList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsCheckCheckListQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsCheckCheckList>>> = ({ signal }) => getPsCheckCheckList(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsCheckCheckList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PS改廃案の承認申請件数を取得する。

 * @summary PS改廃案承認申請件数取得
 */
export const getPsCheckApproveCount = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    return axios.get(
      `/pschecks/approvecount`,options
    );
  }


export const getGetPsCheckApproveCountQueryKey = () => [`/pschecks/approvecount`];

    
export type GetPsCheckApproveCountQueryResult = NonNullable<Awaited<ReturnType<typeof getPsCheckApproveCount>>>
export type GetPsCheckApproveCountQueryError = AxiosError<ErrorInfo>

export const useGetPsCheckApproveCount = <TData = Awaited<ReturnType<typeof getPsCheckApproveCount>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsCheckApproveCount>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsCheckApproveCountQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsCheckApproveCount>>> = ({ signal }) => getPsCheckApproveCount({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsCheckApproveCount>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PS改廃案の承認申請一覧を取得する。

 * @summary PS改廃案承認申請一覧取得
 */
export const getPsCheckApproveList = (
    params?: GetPsCheckApproveListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsCheckApproves>> => {
    return axios.get(
      `/pschecks/approvelist`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetPsCheckApproveListQueryKey = (params?: GetPsCheckApproveListParams,) => [`/pschecks/approvelist`, ...(params ? [params]: [])];

    
export type GetPsCheckApproveListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsCheckApproveList>>>
export type GetPsCheckApproveListQueryError = AxiosError<ErrorInfo>

export const useGetPsCheckApproveList = <TData = Awaited<ReturnType<typeof getPsCheckApproveList>>, TError = AxiosError<ErrorInfo>>(
 params?: GetPsCheckApproveListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsCheckApproveList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsCheckApproveListQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsCheckApproveList>>> = ({ signal }) => getPsCheckApproveList(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsCheckApproveList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

